import axios, { baseUrl } from './axios';
import { get } from 'lodash';

export default {
  createCase: async options => {
    const token = get(options, 'token');

    let transformRequest = {};
    if (token) {
      transformRequest = {
        transformRequest: [
          (data, headers) => {
            headers.common.Authorization = `Bearer ${options.token}`;
            return JSON.stringify(data);
          },
        ],
      };
    }
    const result = await axios.post(
      `${baseUrl}/medicare/pob/patients/${options.patientId}/cases`,
      options.data,
      {},
      transformRequest,
    );
    return result.data;
  },
};
